import { useMemo } from "react"
import { useDispatch } from "react-redux"
import { useGetLojaAtualQuery, type ModoConsumoTotem } from "@/api"
import { BG_PADRAO_TOTEM, ProtecaoTela, slidesComPadrao } from "@/components/protecao-tela"
import { irVista } from "./navegacao"

export default function Atracao({ modo }: { modo: ModoConsumoTotem }): JSX.Element {
    const dispatch = useDispatch()
    const { data: loja } = useGetLojaAtualQuery()

    const slides = useMemo(
        () =>
            slidesComPadrao(
                (loja?.configuracao.imagensTotem ?? []).filter((u): u is string => !!u),
                BG_PADRAO_TOTEM,
            ),
        [loja],
    )

    return (
        <ProtecaoTela
            slides={slides}
            chamadaAcima="Toque para"
            chamadaPrincipal="Fazer seu pedido!"
            nivel="tela"
            aoTocar={() => irVista(dispatch, modo === "AMBOS" ? { currentView: "VIEW_CONSUMO" } : { currentView: "VIEW_CATALOGO", consumo: modo })}
        />
    )
}
